import axios from "axios";
import { store } from "../store";
import config from "../config";
import authHeader from "./auth-header";

const API_URL = config.API_URL;

const buildPayload = (extra = {}) => {
  const auth = store.getState().auth;
  return {
    auth_key: auth.user.auth_key,
    salon_id: auth.user.salon_id,
    ...extra,
  };
};

const status = () => {
  const action = "afterlogin/servicecue/status";
  return axios.post(API_URL + action, buildPayload({ action }), {
    headers: authHeader(),
  });
};

const setup = () => {
  const action = "afterlogin/servicecue/setup";
  return axios.post(API_URL + action, buildPayload({ action }), {
    headers: authHeader(),
  });
};

const regenerate = () => {
  const action = "afterlogin/servicecue/regenerate";
  return axios.post(API_URL + action, buildPayload({ action }), {
    headers: authHeader(),
  });
};

const disconnect = () => {
  const action = "afterlogin/servicecue/disconnect";
  return axios.post(API_URL + action, buildPayload({ action }), {
    headers: authHeader(),
  });
};

const ServiceCueService = {
  status,
  setup,
  regenerate,
  disconnect,
};

export default ServiceCueService;
